<script>
//import catalog from '@/mixins/catalog';
//const ListingCardMobile = () => import ('@/components/listing-card-mobile');

import { register } from 'swiper/element/bundle';
register();

export default {

  name: 'carousel-items',
  props: ['slidesPerView', 'pagination', 'slideId'],  
//   components: {
//                 "listing-card-mobile":ListingCardMobile},
  //mixins: [catalog],
  //template: '#location',
  data: function(){

      return {
        showArrows: true,
        swiperInstance: null,
        slidesCount: 0
      }
  },
  computed: {
    normalizedPagination() {
      // Если pagination явно false (булево или строка "false") - отключаем
      if (this.pagination === false || this.pagination === 'false') {
        return false;
      }
      // По умолчанию включаем пагинацию
      return true;
    },
    breakpointsConfig() {
      const spaceBetween = 20;
      // Если slidesPerView = 4, то настраиваем адаптивные breakpoints
      if (this.slidesPerView === 4) {
        return {
          320: { slidesPerView: 1, spaceBetween },
          768: { slidesPerView: 2, spaceBetween },
          1024: { slidesPerView: 4, spaceBetween }
        };
      }
      // Для других значений используем переданное значение для всех breakpoints
      return {
        320: { slidesPerView: this.slidesPerView || 1, spaceBetween },
        768: { slidesPerView: this.slidesPerView || 1, spaceBetween },
        1024: { slidesPerView: this.slidesPerView || 1, spaceBetween }
      };
    },
    spaceBetweenValue() {
      return 20;
    }
  },
  methods:{
    
    nextSwiper: function(){

        //console.log(this.$refs);
        this.$refs.swiper.swiper.slideNext();

        return false;
    },

    prevSwiper: function()
    {
        this.$refs.swiper.swiper.slidePrev();

        return false;
    },

    updateArrowsVisibility() {
      //console.log('updateArrowsVisibility called, swiperInstance:', this.swiperInstance);
      //console.log("Dsds");
      if (!this.swiperInstance) {
        //console.log('No swiper instance, returning');
        return;
      }
      
      const swiper = this.swiperInstance;
      
      // Получаем количество слайдов через DOM (более надежный способ)
      const swiperEl = this.$refs.swiper;
      let slidesLength = 0;
      
      if (swiperEl) {
        // Получаем все swiper-slide элементы внутри swiper-container
        const slides = swiperEl.querySelectorAll('swiper-slide');
        slidesLength = slides.length;
        //console.log('Found slides:', slidesLength, 'slides:', slides);
      }
      
      // Если нет слайдов или только один слайд, скрываем стрелки
      if (slidesLength <= 1) {
        //console.log('slidesLength <= 1, hiding arrows');
        this.showArrows = false;
        return;
      }
      
      // Получаем текущее значение slidesPerView
      let slidesPerView = swiper.params.slidesPerView;
      //console.log('slidesPerView from params:', slidesPerView);
      
      // Если slidesPerView является объектом (для breakpoints), получаем текущее значение
      if (typeof slidesPerView === 'object') {
        // Для простоты используем максимальное значение
        slidesPerView = Math.max(...Object.values(slidesPerView));
       // console.log('slidesPerView is object, using max value:', slidesPerView);
      }
      
      // Преобразуем в число
      slidesPerView = Number(slidesPerView) || 1;
     // console.log('Final slidesPerView:', slidesPerView, 'slidesLength:', slidesLength);
      
      // Если slidesPerView >= количества слайдов, значит все слайды видны одновременно
      // В этом случае скрываем стрелки, даже если loop включен
      this.showArrows = slidesLength > slidesPerView;
      //console.log('showArrows set to:', this.showArrows);
    },

    onSwiperReady(event) {
      // Получаем экземпляр Swiper
      this.swiperInstance = event.detail[0];
      this.updateArrowsVisibility();
      
      // Добавляем обработчик изменения размера окна
      if (this.swiperInstance) {
        //this.swiperInstance.on('resize', this.updateArrowsVisibility);
        //this.swiperInstance.on('slideChange', this.updateArrowsVisibility);
      }
    }
  },

  mounted() {
    // Добавляем обработчик события инициализации Swiper
    const swiperEl = this.$refs.swiper;
    //console.log('CarouselItems mounted, swiperEl:', swiperEl);
    
    if (swiperEl) {
      swiperEl.addEventListener('swiper', this.onSwiperReady);
      // Также попробуем получить экземпляр напрямую через некоторое время
      setTimeout(() => {
        if (swiperEl.swiper) {
          //console.log('Swiper instance found via swiper property');
          this.swiperInstance = swiperEl.swiper;
          this.updateArrowsVisibility();
        }
      }, 100);
    }
  },

  beforeDestroy() {
    // Удаляем обработчики
    const swiperEl = this.$refs.swiper;
    if (swiperEl) {
      swiperEl.removeEventListener('swiper', this.onSwiperReady);
    }
    
    if (this.swiperInstance) {
      this.swiperInstance.off('resize', this.updateArrowsVisibility);
      this.swiperInstance.off('slideChange', this.updateArrowsVisibility);
    }
  }
}


</script>
<style>

.carousel
{
    position:relative;
}

.nav-swiper
{
    position: absolute;
    top: -28px;
    right: 0px;
}

.nav-swiper>div {
    --swiper-navigation-color: orange;
}
.nav-swiper .left-arrow
{
    right: 45px;
    left:auto;
}

.nav-swiper .right-arrow
{
    right:0;
    left:auto;
}

</style>

<template>
    <div>
        <div class="carousel">
                <div class="nav-swiper" v-if="showArrows">
                   
                   <div class="left-arrow swiper-button-prev" @click="prevSwiper"></div>
                   <div class="right-arrow swiper-button-next" @click="nextSwiper"></div>
               </div>

               <!-- <div class="swiper-pagination d-lg-none"></div> -->
                                <div class="swiper-button-prev swiper-button-prev--simple icon d-none d-lg-flex swiper-button-next--rounded" 
                                     @click.stop.prevent="prevSwiper"
                                     v-if="showArrows">
                                    <!-- <svg-icon name="slider_simple_larr" /> -->
                                    <img :src="require('@/assets/sprite/svg/slider_simple_larr.svg')" alt="">
                                </div>
                                <div class="swiper-button-next swiper-button-next--simple icon d-none d-lg-flex swiper-button-next--rounded" 
                                     @click.stop.prevent="nextSwiper"
                                     v-if="showArrows">
                                    <!-- <svg-icon name="slider_simple_rarr" /> -->
                                    <img :src="require('@/assets/sprite/svg/slider_simple_rarr.svg')" alt="">
                                </div>
            <swiper-container
                    :slides-per-view="slidesPerView"
                    :loop="true"
                    ref="swiper"
                    :pagination="normalizedPagination"
                    :pagination-clickable="normalizedPagination"
                    dynamic-bullets="true"
                    fade="true"
                    space-between="20"
                >        
                <slot></slot>         
                <!-- <swiper-slide v-for="item in proxyData.arResult.ITEMS" :key="item.ID">
                   
                </swiper-slide> -->
            </swiper-container>  
        </div>      
    </div>
             
</template>
